import {
  DATA_USER_GET_ERROR,
  DATA_USER_GET_LOADING,
  DATA_USER_GET_SUCCESS,
} from "actions/constant";
import { combineReducers } from "redux";

const dataUserGetError = (state = false, action) => {
  switch (action.type) {
    case DATA_USER_GET_ERROR:
      return action.dataUserGetError;
    default:
      return state;
  }
};

const dataUserGetLoading = (state = false, action) => {
  switch (action.type) {
    case DATA_USER_GET_LOADING:
      return action.dataUserGetLoading;
    default:
      return state;
  }
};

const dataUserGetSuccess = (state = false, action) => {
  switch (action.type) {
    case DATA_USER_GET_SUCCESS:
      return action.dataUserGetSuccess;
    default:
      return state;
  }
};

const dataUsers = (state = [], action) => {
  switch (action.type) {
    case DATA_USER_GET_SUCCESS:
      return action.dataUsers;
    default:
      return state;
  }
};

const dataUsersReducer = combineReducers({
  dataUserGetError,
  dataUserGetLoading,
  dataUserGetSuccess,
  dataUsers,
});

export default dataUsersReducer;
